// extracted by mini-css-extract-plugin
export default {"TableHeader":"TableHeader_TableHeader__MMqcN","no-rounded-top":"TableHeader_no-rounded-top__6f70y","left":"TableHeader_left__4bXFD","right":"TableHeader_right__kNdE7"};